var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"info"},[_c('h3',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.a3user.id)+" "),_c('br')])])])}
var staticRenderFns = []

export { render, staticRenderFns }